// Mirrors the `engine` enum shared by BuyerProfile and BuyerSet on the
// backend (system repo PR #61) - a buyer's engine must match every
// BuyerSet it belongs to, so both BuyersPage and BuyerSetsPage need the
// same value/label pairing to filter and warn consistently.
export const ENGINE_OPTIONS = [
  { value: 'waterfall', label: 'Waterfall' },
  { value: 'ping_post', label: 'Ping/Post Auction' },
  { value: 'direct', label: 'Direct Post' }
]

export const ENGINE_LABELS = Object.fromEntries(ENGINE_OPTIONS.map(o => [o.value, o.label]))
